export const socials = [
    {
        icon:  'fa-brands fa-twitter',
        link: 'https://twitter.com/onedex_x'
    },
    {
        icon:  'fa-regular fa-paper-plane',
        link: 'https://t.me/one_dex_multiversx'
    },
];